// src/modules/fleetoperationdashboard/FleetOperationModule.jsx
import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import FleetOperationDashboard from "./FleetOperationDashboard";

const FleetOperationModule = () => {
  const navItems = routeModules?.fleetoperation?.sidebar || [];

  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Define which items should render the dashboard
  const dashboardItems = ["Fleet Operation Dashboard"];

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    // Check if the active item is in our dashboard items list
    if (dashboardItems.includes(activeItem)) {
      return <FleetOperationDashboard />;
    }
    
    // If there's no active item but we have nav items, show the first one
    if (!activeItem && navItems.length > 0) {
      return <FleetOperationDashboard />;
    }
    
    // Default fallback
    return <Typography>Need Access</Typography>;
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Layout
        module={"fleetoperation"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          width: "50%",
        }}
      >
        <Toolbar />

        <Container
          maxWidth={false}
          sx={{ flexGrow: 1, minHeight: "100vh", overflow: "hidden" }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default FleetOperationModule;